<div id="piaChartForPaperSubmissionMonthly" style="width: 600px; height: 400px;"></div>
